import { type PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"

export const canViewFinanceTab = (
  permissions: PermissionProjectPermissions | undefined
): boolean => !!permissions?.finances?.project_finance_view

export const canViewFinanceSnapshot = (
  permissions: PermissionProjectPermissions | undefined
): boolean =>
  !!permissions?.features?.project_snapshot_sales ||
  !!permissions?.features?.project_snapshot_commissions
